import { cn } from "@/lib/utils";
import SectionCard from "@/components/SectionCard";

const severidadConfig = {
  alta: { bg: "bg-rose-50", border: "border-rose-200", text: "text-rose-700", badge: "bg-rose-500" },
  media: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", badge: "bg-amber-500" },
  baja: { bg: "bg-slate-50", border: "border-slate-200", text: "text-slate-600", badge: "bg-slate-400" },
};

export default function PanelQuiebres({ quiebres, color }) {
  const top3 = quiebres.slice(0, 3);

  return (
    <SectionCard
      title="Quiebres críticos"
      subtitle="Top problemas identificados"
      testid="panel-quiebres"
    >
      <div className="space-y-3">
        {top3.map((q, i) => {
          const cfg = severidadConfig[q.severidad] || severidadConfig.baja;
          return (
            <div key={i} className={cn("rounded-xl border p-4", cfg.bg, cfg.border)}>
              <div className="flex items-center gap-2">
                <span className={cn("px-2 py-0.5 rounded-full text-[10px] font-bold text-white uppercase", cfg.badge)}>
                  {q.severidad}
                </span>
                {q.porcentaje != null && (
                  <span className={cn("text-lg font-bold", cfg.text)}>{q.porcentaje}%</span>
                )}
              </div>
              <p className="text-sm text-slate-700 mt-2">{q.descripcion}</p>
              <p className="text-xs text-slate-500 mt-1">{q.motivo}</p>
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
}
